import React, { useEffect, useState } from 'react';
import { ClientPrivate } from '../model/Client';
import { showMessage } from '../services/popup';
import { getClients } from '../services/service';
import { ClientComponent } from '../components/ClientComponent';

const SIZE = 20;

const ClientTab: React.FC = () => {
  const [page, setPage] = useState(0);
  const [clients, setClients] = useState<ClientPrivate[]>([]);
  const [current, setCurrent] = useState<ClientPrivate | undefined>(undefined);
  const [pattern, setPattern] = useState('');

  const loadClients = async (p: number, currentPattern?: string) => {
    try {
      const c = await getClients(currentPattern ?? pattern, p * SIZE, SIZE + 1);
      setClients(c);
    } catch (e) {
      showMessage('Une erreur est survenue: ' + JSON.stringify(e));
    }
  };

  const hasNext = clients.length > SIZE;
  const hasPrevious = page > 0;

  const movePage = (next: number) => {
    if (next >= 0) {
      setPage(next);
      loadClients(next);
    }
  };

  const search = () => {
    setPage(0);
    loadClients(0, pattern);
  };

  useEffect(() => {
    loadClients(0, '');
  }, []);

  if (current) {
    return (
      <div className="page-stack">
        <button className="ghost-btn" onClick={() => setCurrent(undefined)}>Retour liste clients</button>
        <ClientComponent client={current} />
      </div>
    );
  }

  return (
    <div className="page-stack">
      <section className="panel">
        <div className="toolbar-row">
          <input value={pattern} onChange={(e) => setPattern(e.target.value)} placeholder="Rechercher un client" />
          <button className="primary-btn" onClick={search}>Rechercher</button>
          <div className="pager-inline">
            <button className="ghost-btn" disabled={!hasPrevious} onClick={() => movePage(page - 1)}>Precedent</button>
            <span>Page {page + 1}</span>
            <button className="ghost-btn" disabled={!hasNext} onClick={() => movePage(page + 1)}>Suivant</button>
          </div>
        </div>

        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Nom</th>
                <th>Telephone</th>
                <th>Adresse</th>
                <th>Email</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {clients.slice(0, SIZE).map((c, i) => (
                <tr key={i}>
                  <td className="mono">{c.client.id}</td>
                  <td>{c.client.firstname} {c.client.lastname}</td>
                  <td>{c.client.phoneNumber}</td>
                  <td>{c.address.description}</td>
                  <td>{c.email}</td>
                  <td><button className="ghost-btn" onClick={() => setCurrent(c)}>Voir</button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
};

export default ClientTab;
